@if (mapService.featureInfoChartData) {
    <ag-charts [options]="mapService.featureInfoChartData" style="display: block;"></ag-charts>
}